import { css } from '@emotion/react';

import { defaultTheme } from '../../themes/theme';

const defaultStyles = css({
  ...defaultTheme.eclipseTier2Typography.bodyMd,
  color: defaultTheme.eclipseTier2Color.text.default,
});

const globalStyles = css({
  body: defaultStyles,
});

export const S = {
  defaultStyles,
  globalStyles,
};
